import Phaser from 'phaser';

import { getDevicePixelRatio } from '@/shared/utils/phaserCanvasSize';
import TracingGameScene, { TRACING_GAME_SCENE_HEIGHT, TRACING_GAME_SCENE_WIDTH } from './scenes/TracingGameScene';

export function createGameConfig(parent: HTMLElement): Phaser.Types.Core.GameConfig {
	const devicePixelRatio = getDevicePixelRatio();

	return {
		type: Phaser.CANVAS,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || TRACING_GAME_SCENE_WIDTH) * devicePixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || TRACING_GAME_SCENE_HEIGHT) * devicePixelRatio)),
		transparent: true,
		scene: [TracingGameScene],
		scale: {
			mode: Phaser.Scale.NONE,
		},
		antialias: true,
		roundPixels: false,
	};
}
